import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import KnowledgeBase from "./pages/KnowledgeBase";
import Escalations from "./pages/Escalations";
import IvrDemo from "./pages/IvrDemo";
import CallDemo from "./pages/CallDemo";
import SipConfigure from "./pages/SipConfigure";
import CallLogs from "./pages/CallLogs";
import Settings from "./pages/Settings";
import Billing from "./pages/Billing";
import SuperAdmin from "./pages/SuperAdmin";

function ShellRoute({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/app/dashboard" element={<ShellRoute><Dashboard /></ShellRoute>} />
            <Route path="/app/knowledge" element={<ShellRoute><KnowledgeBase /></ShellRoute>} />
            <Route path="/app/escalations" element={<ShellRoute><Escalations /></ShellRoute>} />
            <Route path="/app/demo" element={<ShellRoute><IvrDemo /></ShellRoute>} />
            <Route path="/app/call-demo" element={<ShellRoute><CallDemo /></ShellRoute>} />
            <Route path="/app/sip" element={<ShellRoute><SipConfigure /></ShellRoute>} />
            <Route path="/app/calls" element={<ShellRoute><CallLogs /></ShellRoute>} />
            <Route path="/app/settings" element={<ShellRoute><Settings /></ShellRoute>} />
            <Route path="/app/billing" element={<ShellRoute><Billing /></ShellRoute>} />

            <Route path="/admin" element={<Navigate to="/admin/tenants" replace />} />
            <Route path="/admin/tenants" element={
              <ProtectedRoute requireRole="super_admin">
                <AppShell><SuperAdmin /></AppShell>
              </ProtectedRoute>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
